module.exports = __webpack_public_path__ + "img/logo.53c1a6de.png";